import { useCallback } from 'react';
import { analytics } from '../analytics';
import type { AnalyticsEventName, TrackArgs } from '../types';

/** Typed `track` for React components. Prefer after successful outcomes.
 * @returns true if the event was delivered to the provider.
 */
export function useAnalytics() {
    const track = useCallback(
        <K extends AnalyticsEventName>(
            event: K,
            ...args: TrackArgs<K>
        ): boolean => {
            return analytics.track(event, ...args);
        },
        []
    );

    return { track };
}
